import styled from '@emotion/styled/macro';
import { forPhoneOnly, Layout, LayoutRow, Variables } from '@enter/core';
import mdiChevronRight from '@mdi/svg/svg/chevron-right.svg';
import { Link } from 'react-router-dom';

interface IPageLayoutRow {
    expand?: boolean;
}

export const PageLayout = styled(Layout)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 48px;
    overflow-x: hidden;
    overflow-y: auto;

    ${forPhoneOnly(`
        margin-left: 0;
        padding: 16px;
        height: 100%;
    `)};
`;

export const PageLayoutRow = styled(LayoutRow)<IPageLayoutRow>`
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    ${(props: IPageLayoutRow): string => (props.expand ? 'flex-grow: 1;' : '')}
`;

export const PageLayoutHeader = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`;
export const PageLayoutTitle = styled.h1`
    margin: 0;
    height: 28px;
    font-family: Calibre;
    font-size: 28px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.p500};
`;

export const PageLayoutBreadcrumbLink = styled(Link)`
    display: inline-flex;
    align-items: center;

    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.p500};
`;

export const PageLayoutBreadcrumb = styled.div`
    display: flex;
    align-items: center;

    & > ${PageLayoutBreadcrumbLink}:not(:last-of-type):after {
        display: inline-block;
        content: ' ';
        background: url(${mdiChevronRight});
        background-size: 24px auto;
        height: 24px;
        width: 24px;
    }
`;
